import { useProtectedQuery } from "@/hooks/use-protected-query";
import { fetchData } from "@/utils/api-handler";
import {
  buildDataTablesQuery,
  DEFAULT_DATA_TABLE_SORT,
} from "@/utils/data-tables";

async function fetchAllDataTables(): Promise<DataTable[]> {
  const allItems: DataTable[] = [];
  let page = 1;
  let pageCount = 1;

  while (page <= pageCount) {
    const response = (await fetchData(
      buildDataTablesQuery({
        page,
        search: "",
        sortBy: DEFAULT_DATA_TABLE_SORT.sortBy,
        sortOrder: DEFAULT_DATA_TABLE_SORT.sortOrder,
      })
    )) as DataTablesListResponse;

    allItems.push(...(response.items ?? []));
    pageCount = response.page_count ?? 1;
    page += 1;
  }

  return allItems;
}

export function useAllDataTables() {
  return useProtectedQuery<DataTable[]>({
    queryKey: ["data-tables-all"],
    queryFn: fetchAllDataTables,
    requiredPermissions: [],
  });
}
